import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setPage,
  setMaxPages,
  setSorting,
  setSearchQuery,
  setSearchValue,
  setStatus,
  setType,
  setIsRecurring,
  setTotalCount,
  setCheckedItems,
  toggleAddModal,
  toggleEditModal,
  setViewedNotification,
} from '../../store/notificationsTabSlice.js';
import {
  getHeaders,
  headerWidths,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  statusFilterOptions,
  typeFilterOptions,
  recurringFilterOptions,
  empty,
} from './notificationsTableConfig.js';
import { fetchNotifications } from './notificationsTableService.js';
import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import AddNotificationModal from './addNotificationModal.jsx';
import EditNotificationModal from './editNotificationModal.jsx';
import './Notifications.css';

function Notifications() {
  const dispatch = useDispatch();
  const totalPages = useSelector((state) => state.notifications.maxPages);
  const currentPage = useSelector((state) => state.notifications.currentPage);
  const sortBy = useSelector((state) => state.notifications.sortBy);
  const sortDirection = useSelector((state) => state.notifications.sortDirection);
  const checkedItems = useSelector((state) => state.notifications.checkedItems);
  const searchQuery = useSelector((state) => state.notifications.searchQuery);
  const searchValue = useSelector((state) => state.notifications.searchValue);
  const status = useSelector((state) => state.notifications.status);
  const type = useSelector((state) => state.notifications.type);
  const dateFrom = useSelector((state) => state.notifications.dateFrom);
  const dateTo = useSelector((state) => state.notifications.dateTo);
  const isRecurring = useSelector((state) => state.notifications.isRecurring);
  const totalCount = useSelector((state) => state.notifications.totalCount);
  const showAddModal = useSelector((state) => state.notifications.showAddModal);
  const showEditModal = useSelector((state) => state.notifications.showEditModal);
  const viewedNotification = useSelector((state) => state.notifications.viewedNotification);

  const [rows, setRows] = useState([]);
  const [notificationsData, setNotificationsData] = useState([]);
  const sortArrowColorActive = '#FFFFFF';
  const sortArrowColorInactive = 'rgba(255,255,255,0.45)';

  useEffect(() => {
    fetchNotifications(
      sortBy,
      sortDirection,
      currentPage,
      dispatch,
      setMaxPages,
      setRows,
      setTotalCount,
      setNotificationsData,
      checkedItems,
      searchQuery,
      status,
      type,
      dateFrom,
      dateTo,
      isRecurring
    );
  }, [
    currentPage,
    sortBy,
    sortDirection,
    checkedItems,
    searchQuery,
    status,
    type,
    dateFrom,
    dateTo,
    isRecurring,
  ]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rows,
    checkedItems,
    notificationsData,
    setCheckedItems
  );

  const paginationProps = {
    reduxSelector: (state) => state.notifications.currentPage,
    reduxAction: setPage,
    totalPages: totalPages,
    maxVisibleButtons: 5,
  };

  const rightSideConfig2 = [
    {
      component: Pagination,
      props: paginationProps,
    },
  ];

  // Create fetch params for delete action
  const fetchParams = [
    sortBy,
    sortDirection,
    currentPage,
    dispatch,
    setMaxPages,
    setRows,
    setTotalCount,
    setNotificationsData,
    checkedItems,
    searchQuery,
    status,
    type,
    dateFrom,
    dateTo,
    isRecurring,
  ];

  const handleToggleAddModal = () => {
    dispatch(toggleAddModal());
  };

  const handleEditNotification = (notificationId) => {
    dispatch(setViewedNotification(notificationId));
    dispatch(toggleEditModal());
  };

  return (
    <div>
      <Menu />
      <Content>
        <LineWithButtons
          tabs={[]}
          buttons={buttonsConfig(handleToggleAddModal)}
          rightSide={rightSideConfig(dispatch, checkedItems, fetchNotifications, ...fetchParams)}
        />
        <div className="notifications-info">
          <span className="notifications-count">Wyszukano: {totalCount} wyników</span>
        </div>
        <div className="notifications-filters">
          <div className="filter-group">
            <select
              className="filter-select"
              value={status || ''}
              onChange={(e) => {
                dispatch(setStatus(e.target.value || null));
              }}
            >
              {statusFilterOptions.map((option) => (
                <option key={option.value || 'empty'} value={option.value || ''}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-group">
            <select
              className="filter-select"
              value={type || ''}
              onChange={(e) => {
                dispatch(setType(e.target.value || null));
              }}
            >
              {typeFilterOptions.map((option) => (
                <option key={option.value || 'empty'} value={option.value || ''}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-group">
            <select
              className="filter-select"
              value={isRecurring !== null ? String(isRecurring) : ''}
              onChange={(e) => {
                const value = e.target.value;
                dispatch(setIsRecurring(value === '' ? null : value === 'true'));
              }}
            >
              {recurringFilterOptions.map((option) => (
                <option key={option.value || 'empty'} value={option.value || ''}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="table-container">
          <Table
            headers={headers}
            rows={rows}
            columnWidths={headerWidths}
            idViewing={false}
            idArrayId={1}
            cellClass2="cell-center"
            cellClass2ConditionList={[4, 5, 6, 8, 9]} // Target users, Total sent, Firebase, RabbitMQ, Status, Type
          />
          <UniversalLineWithComponents
            leftSide={leftSideConfig(dispatch, status, type, isRecurring, searchValue, setSearchQuery)}
            rightSide={rightSideConfig2}
          />
        </div>
      </Content>
      {showAddModal && <AddNotificationModal />}
      {showEditModal && <EditNotificationModal notificationId={viewedNotification} />}
    </div>
  );
}

export default Notifications;
